import { Helmet, HelmetProvider } from 'react-helmet-async';
import WatchListSection from "shared/components/rental/sections/watchlist-section";

const Watchlist = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Watchlist | Yally</title>
        </Helmet>
      </HelmetProvider>

      <WatchListSection />
    </>
  );
};

export default Watchlist;
